import { render, staticRenderFns } from "./SchedaValutazioneEsigenzeImmediateViewComponent.vue?vue&type=template&id=86aa610a"
import script from "./SchedaValutazioneEsigenzeImmediateViewComponent.vue?vue&type=script&lang=js"
export * from "./SchedaValutazioneEsigenzeImmediateViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports